import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { contractStatusTypesClient } from '../../api';
import { BookingStatusType } from '../../models';
import { RootState } from '../store';

const adapter = createEntityAdapter<BookingStatusType>({
    selectId: (x) => x.id,
    sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const getAll = createAsyncThunk('contractStatusTypes/getall', async (thunkAPI) => {
    const response = await contractStatusTypesClient.getAll();
    return response;
});

const slice = createSlice({
    name: 'contractStatusTypes',
    initialState: adapter.getInitialState({
        isLoading: false,
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAll.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(getAll.fulfilled, (state, action) => {
            adapter.setAll(state, action.payload);
        });
    },
});

const selectors = adapter.getSelectors<RootState>((state) => state.contractStatusTypes);
const contractStatusTypesSelectors = { ...selectors };
const contractStatusTypesActions = { ...slice.actions, getAll };

export default slice.reducer;
export { contractStatusTypesSelectors, contractStatusTypesActions };
